import { filterAlerts, computeAlertStatusStats, ALL_ALERTS } from '../fixtures/alerts';

const paginate = (items, params) => {
  const page = Number(params.page || 0);
  const size = Number(params.size || 10);
  const start = page * size;
  const slice = items.slice(start, start + size);
  return {
    content: slice,
    number: page,
    size,
    totalElements: items.length,
    totalPages: Math.max(1, Math.ceil(items.length / size)),
    first: page === 0,
    last: start + size >= items.length,
  };
};

export default [
  {
    method: 'GET',
    pattern: /^\/customer-ms\/api\/v1\/alerts$/,
    handler: ({ params }) => paginate(filterAlerts(params), params),
  },
  {
    method: 'GET',
    pattern: /^\/customer-ms\/api\/v1\/alerts\/stat-by-status$/,
    handler: () => computeAlertStatusStats(),
  },
  {
    method: 'PUT',
    pattern: /^\/customer-ms\/api\/v1\/alerts$/,
    handler: ({ body }) => {
      if (Array.isArray(body)) {
        body.forEach((upd) => {
          const idx = ALL_ALERTS.findIndex((a) => a.id === upd.id);
          if (idx >= 0) ALL_ALERTS[idx] = { ...ALL_ALERTS[idx], ...upd, updateDate: new Date().toISOString() };
        });
      } else if (body && body.id) {
        const idx = ALL_ALERTS.findIndex((a) => a.id === body.id);
        if (idx >= 0) ALL_ALERTS[idx] = { ...ALL_ALERTS[idx], ...body, updateDate: new Date().toISOString() };
      }
      return { updated: true };
    },
  },
];
